import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { MLPAScrollingTableHeaderComponent } from 'ml-components-common-react';
import { MLTooltipComponent } from 'ml-components-platform-react'

import messages from './MLRewriteStickyHeader.messages'
import styles from './MLRewriteStickyHeader.module.scss'
import metadata from './MLRewriteStickyHeader.metadata.json5'
import metadataPA from './MLRewriteStickyHeader.pa.metadata.json5'

import { IntlContext } from '@jutro/legacy/locale';

function MLRewriteStickyHeader(props){
    const { 
        layout,
        submissionVM,
        model,
        isDisplayOnly,
        isAlaska7Day,
        termMonths,
        quoteStatus,
        hasNamedNonOwner,
        isPolicyChange,
        prevIndex,
        nextIndex,
        isPrevAvailable,
        isNextAvailable,
        coverablesToDisplay,
        updateMaps,
        onPrevButtonClick,
        onNextButtonClick,
        navigateToStep,
        filterData
    } = props;
    const translator =  useTranslator();
    const intl = useContext(IntlContext)

    const [totalPremium, updateTotalPremium] = useState();
    const [homeReplacementCostMessage, updateHomeReplacementCostMessage] = useState({});
    const [visible, updateVisibility] = useState(false);
    const [pageContentGPAWidth, updatePageContentGPAWidth] = useState("0px");
     const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const showStickyHeader = () => {
        updateVisibility(true);
    }

    const hideStickyHeader = () => {
        updateVisibility(false);
    }

    const handleScrollEvent = () => {
        const allTopDetails = document.querySelector('div[id^=\'topDetails_\']')
        const stickyOffSet = allTopDetails.offsetTop + allTopDetails.clientHeight;
        if (layout === 'pa') {
            // buildAutoScrollingHeader();
        }
        if (window.scrollY >= stickyOffSet) {
            showStickyHeader();
        } else {
            hideStickyHeader();
        }
    };

    const handleResize = () => {
        try{
            const computedStyle = getComputedStyle(document.getElementById("pageContainer"))
            updatePageContentGPAWidth(`${parseFloat(computedStyle.width) - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight)}px`);
        }catch{
            updatePageContentGPAWidth("0px")
        }
    }

    const getTotalPremium = () => {
        let _totalPremium = 0;
        let returnObj = {};
        if (layout === 'pa') {
            const vehicleCoverages = submissionVM.coverageLobs.value.personalAuto.vehicleCoverages;
            vehicleCoverages.forEach((vehicleCov) => {
                _totalPremium += vehicleCov.vehicleCost_ML.amount;
            });
            returnObj = {
                amount: _totalPremium,
                currency: 'usd'
            };
        } else {
            returnObj = submissionVM.value.totalPremium;
        }

        return returnObj;
    }

    const formatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    const getEstimatedReplacementCostMessage = () => {
        const _homeReplacementCostMessage = {};
        const cost = formatCurrency(submissionVM.coverageLobs.homeowners.replacementCost_ML.value || { amount: 0, currency: 'usd'});
        const partType = submissionVM.coverageLobs.homeowners.coveragePartType_ML.value;
        if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(partType.code)) {
            _homeReplacementCostMessage.message = translator(messages.replacementCostContents, {
                replacementCost: cost
            });
            _homeReplacementCostMessage.help = translator(messages.helpRenter);
        } else {
            _homeReplacementCostMessage.message = translator(messages.replacementCostDwelling, {
                replacementCost: cost
            });
            _homeReplacementCostMessage.help = translator(messages.helpCondo);
        }
        return _homeReplacementCostMessage;
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScrollEvent);
        window.addEventListener('resize', handleResize);
        updateTotalPremium(getTotalPremium());
        if(layout === "ho"){
            updateHomeReplacementCostMessage(getEstimatedReplacementCostMessage());
        }
        handleResize();
        return () => {
            window.removeEventListener('scroll', handleScrollEvent);
            window.removeEventListener('resize', handleResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const overrideProps = {
        componentContainer: {
            visible: visible,
            style: {
                width: pageContentGPAWidth
            }
        },
        hoRow: {
            visible: layout === 'ho'
        },
        umbRow: {
            visible: layout === 'umb'
        },
        hoParagraph: {
            visible: !!homeReplacementCostMessage.message
        },
        hoParagraphText: {
            content: homeReplacementCostMessage.message
        },
        hoTooltip: {
            tooltipContent: homeReplacementCostMessage.help
        },
        premiumAmount: {
            content: translator(messages.amountPerMonth, {
                totalPremium: formatCurrency(getTotalPremium())
            })
        },
        totalAmountColumn: {
            content: translator(messages.amount, {
                totalPremium: formatCurrency(getTotalPremium())
            })
        },
        scrollingHeader: {
            model,
            isDisplayOnly,
            isAlaska7Day,
            termMonths,
            quoteStatus,
            hasNamedNonOwner,
            isPolicyChange,
            prevIndex,
            nextIndex,
            isPrevAvailable,
            isNextAvailable,
            coverablesToDisplay,
            updateMaps,
            onPrevButtonClick,
            onNextButtonClick,
            navigateToStep,
            filterData,
            isModernProduct
        }
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLPAScrollingTableHeaderComponent,
            MLTooltipComponent
        }
    }

    return(
        <ViewModelForm
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            overrideProps={overrideProps}
            uiProps={layout === 'pa' ? metadataPA.componentContent : metadata.componentContent}
        />
    );
}

export default MLRewriteStickyHeader;